import type { FC, InputHTMLAttributes, ReactNode } from 'react'
import { useFieldContext } from './Field.js'

type NativeProps = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'value' | 'onChange' | 'className' | 'size'
>

export interface InputProps extends NativeProps {
  value: string
  /** Receives the string value, not the event — every value here is a string. */
  onChange: (value: string) => void
  placeholder?: string
  icon?: ReactNode
  invalid?: boolean
  /** Money, quantity and rate inputs align right with tabular figures. */
  align?: 'left' | 'right'
}

export const Input: FC<InputProps> = ({
  value,
  onChange,
  placeholder,
  icon,
  invalid,
  align = 'left',
  id,
  ...rest
}) => {
  const field = useFieldContext()
  const bad = invalid ?? field?.invalid ?? false

  const className = [
    'control',
    icon ? 'control--with-icon' : '',
    align === 'right' ? 'control--right num' : '',
    bad ? 'control--invalid' : '',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <span className="control-wrap">
      {icon ? <span className="control__icon">{icon}</span> : null}
      <input
        {...rest}
        id={id ?? field?.id}
        className={className}
        value={value}
        placeholder={placeholder}
        aria-invalid={bad || undefined}
        aria-describedby={field?.describedBy}
        aria-required={field?.required || undefined}
        onChange={(e) => onChange(e.currentTarget.value)}
      />
    </span>
  )
}
